/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ModulesWebhooksDomainWebhookSubscriptionsWebhookType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const ModulesWebhooksDomainWebhookSubscriptionsWebhookType = {
    NUMBER_1: 1 as ModulesWebhooksDomainWebhookSubscriptionsWebhookType,
    NUMBER_2: 2 as ModulesWebhooksDomainWebhookSubscriptionsWebhookType,
    NUMBER_3: 3 as ModulesWebhooksDomainWebhookSubscriptionsWebhookType,
    NUMBER_4: 4 as ModulesWebhooksDomainWebhookSubscriptionsWebhookType,
    NUMBER_5: 5 as ModulesWebhooksDomainWebhookSubscriptionsWebhookType,
    NUMBER_6: 6 as ModulesWebhooksDomainWebhookSubscriptionsWebhookType,
    NUMBER_7: 7 as ModulesWebhooksDomainWebhookSubscriptionsWebhookType,
    NUMBER_8: 8 as ModulesWebhooksDomainWebhookSubscriptionsWebhookType
};